import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CommonStatCard from "../pt/pt-flow-new/CommonStatCard";
import { getCardLabel, getCardValue } from "../common-data/Conversions";
import CalendarLoader from "../common-components/CalendarLoader";

const EXCLUDED_KEYS = ["total_converted_amount"];

const STAT_ORDER = [
  "total",
  "total_pending",
  "total_completed",
  "total_converted",
  "total_not_converted",
  "total_added_to_lead",
  "total_not_added_to_lead",
];

const ODMStats = () => {
  const { oneDayStatsLoading, oneDayStats } = useSelector(
    (state) => state.plans
  );

  const iniDatas = {
    allStats: {},
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  useEffect(() => {
    if (oneDayStats?.status && oneDayStats?.data) {
      setAllDatas((prevs) => ({
        ...prevs,
        allStats: oneDayStats.data,
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [oneDayStats]);

  const sortedCards =
    allDatas.allStats &&
    Object?.entries(allDatas.allStats)
      ?.sort(([keyA], [keyB]) => {
        const indexA = STAT_ORDER.indexOf(keyA);
        const indexB = STAT_ORDER.indexOf(keyB);

        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      })
      ?.map(([key, value], index) => (
        <React.Fragment key={index}>
          {!EXCLUDED_KEYS.includes(key) && (
            <CommonStatCard
              tagName={key}
              cardLabel={getCardLabel(key, false, "odm")}
              value={getCardValue(
                key,
                value || 0,
                allDatas.allStats?.total_converted_amount
              )}
            />
          )}
        </React.Fragment>
      ));

  return (
    <div className="cards-container cards-grid-container grid-5">
      {oneDayStatsLoading ? (
        <CalendarLoader
          daysCount={5}
          shiftsPerDay={2}
          // containerClassName="card-loader"
        />
      ) : (
        sortedCards
      )}
    </div>
  );
};

export default ODMStats;
